module.exports = __webpack_public_path__ + "media/images/howitworks2-4b2e0f98d68416db878625f47d867e5b.png";